import { render } from "./Ad-Be.vue?vue&type=template&id=10bce82c&scoped=true&lang=pug"
import script from "./Ad-Be.vue?vue&type=script&lang=js"
export * from "./Ad-Be.vue?vue&type=script&lang=js"

import "./Ad-Be.vue?vue&type=style&index=0&id=10bce82c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10bce82c"]])

export default __exports__